// import React, { useState } from "react";
// import "./Sidebar.css";
// import { FaHome, FaCog, FaUser, FaBars, FaTimes } from "react-icons/fa";
// import ganeshlogo from '../images/ganeshlogo.jpeg'
// import headertemple from '../images/headertemple.jpeg'

// const Sidebar = () => {
//   const [isOpen, setIsOpen] = useState(false);

//   // Toggle function
//   const toggleSidebar = () => {
//     setIsOpen(!isOpen);
//   };

//   return (
//     <div>
//       <div className={`sidebar ${isOpen ? "open" : "closed"}`}>
//         <ul>
// <img 
//     src={ganeshlogo} 
//     className="image" 
//     alt="Ganesh Logo"
//   />
//           <li>
//             <FaHome />
//             {isOpen && <span>Home</span>}
//           </li>
//           <li>
//             <FaCog />
//             {isOpen && <span>Settings</span>}
//           </li>
//           <li>
//             <FaUser />
//             {isOpen && <span>Profile</span>}
//           </li>
//         </ul>
//       </div>
//       <div className={`content ${isOpen ? "shifted" : ""}`}>
//         <button onClick={toggleSidebar} className="toggle-btn">
//           {isOpen ? <FaTimes /> : <FaBars />}
//         </button>
//         <header className="header">
//             <img src={headertemple} alt="Header" className="HeaderImag" />
//           </header>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;





// import React, { useState } from "react";
// import "./Sidebar.css";
// import headertemple from '../images/headertemple.jpeg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBars, faHome, faChartLine, faUser, faEnvelope, faCog,faBox,faCreditCard, faTicketAlt} from '@fortawesome/free-solid-svg-icons';
// import ganeshlogo from '../images/ganeshlogo.jpeg'
// import { FaOm } from "react-icons/fa6";
// import { FaUnity } from "react-icons/fa";
// import { BiSolidPurchaseTag } from "react-icons/bi";
// import { GiTicket } from "react-icons/gi";
// import { faShoppingCart, faBoxOpen, faChartBar } from '@fortawesome/free-solid-svg-icons';


// function Sidebar() {
//   const [isOpen, setIsOpen] = useState(false); // State for managing the sidebar's open/closed state
//   const [isSidebarClosed, setIsSidebarClosed] = useState(false); // State for mobile/desktop sidebar view

//   const toggleNav = () => {
//     setIsOpen(!isOpen);
//     if (window.innerWidth <= 1768) {
//       setIsSidebarClosed(!isSidebarClosed);
//     }
//   };

//   return (
//     <>
//       <div id="mySidebar" className={`sidebar ${isSidebarClosed ? 'closed' : ''} ${isOpen ? 'open' : ''}`}>
//         <div className="sidebar-header">
//           <img
//             src={ganeshlogo}
//             className="h3"
//             alt="Ganesh Logo"

//           />
//           <button className="toggle-btn" onClick={toggleNav}>
//             <FaOm />
//           </button>
//         </div>
//         <a href="/home"><FontAwesomeIcon icon={faHome} style={{ margin: '10px' }} /> <span>Home</span></a>
//         <a href="/productCategory"><FontAwesomeIcon icon={faChartLine} style={{ margin: '10px' }} /> <span>Product Category</span></a>
//         <a href="/productUnit"><FontAwesomeIcon icon={faBox} style={{ margin: '10px' }} /> <span>Product Unit</span></a>
//         <a href="/poojaManagement"><FontAwesomeIcon icon={faEnvelope} style={{ margin: '10px' }} /> <span>Manage Pooja</span></a>
//         <a href="/user"><FontAwesomeIcon icon={faUser} style={{ margin: '10px' }} /> <span>Users</span></a>
//         <a href="/order"><FontAwesomeIcon icon={faCreditCard} style={{ margin: '10px' }} /> <span>Purchases</span></a>
//         <a href="/poojaBooking"><FontAwesomeIcon icon={faTicketAlt} style={{ margin: '10px' }} /> <span>Pooja Ticket Booking</span></a>
//         <a href="/viewBooking"><FontAwesomeIcon icon={faShoppingCart} style={{ margin: '10px' }} /> <span>View Bookings</span></a>
//         <a href="/purchaseToStoke"><FontAwesomeIcon icon={faBoxOpen} style={{ margin: '10px' }} /> <span>Purchase To Stoke</span></a>
//         <a href="/stockDetails"><FontAwesomeIcon icon={faChartBar} style={{ margin: '10px' }} /> <span>View Stock</span></a>
//         <a href="/report"><FontAwesomeIcon icon={faCog} style={{ margin: '10px' }} /> <span>Reports</span></a>

//       </div>

//       <div id="main" >

//         <img src={headertemple} alt="Header" className="HeaderImag" />

//       </div>



//     </>
//   );
// }

// export default Sidebar;




// import React, { useState, useEffect } from "react";
// import "./Sidebar.css";
// import headertemple from '../images/headertemple.jpeg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBars, faHome, faChartLine, faUser, faEnvelope, faCog, faBox, faCreditCard, faTicketAlt } from '@fortawesome/free-solid-svg-icons';
// import ganeshlogo from '../images/ganeshlogo.jpeg';
// import { FaOm, FaUserCircle, FaSignOutAlt } from "react-icons/fa";
// import { BiSolidPurchaseTag } from "react-icons/bi";
// import { GiTicket } from "react-icons/gi";
// import { faShoppingCart, faBoxOpen, faChartBar } from '@fortawesome/free-solid-svg-icons';
// import { Dropdown } from 'react-bootstrap';
// import Swal from "sweetalert2";
// import swal from 'sweetalert';
// import { useNavigate } from 'react-router-dom';

// function Sidebar() {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isSidebarClosed, setIsSidebarClosed] = useState(false);
//   const [role, setRole] = useState(null); // State to store the user's role

//   useEffect(() => {
//     // Fetch the role from sessionStorage on component mount
//     const userRole = sessionStorage.getItem("role");
//     setRole(userRole);  // Set the role state
//   }, []);

//   const toggleNav = () => {
//     setIsOpen(!isOpen);
//     if (window.innerWidth <= 1768) {
//       setIsSidebarClosed(!isSidebarClosed);
//     }
//   };

//   const navigate = useNavigate();

//   const handleLogout = () => {
//     sessionStorage.clear();  // Clear all session storage data
//     swal('Logged Out', 'You have been logged out successfully!', 'success')
//       .then(() => {
//         navigate('/');  // Redirect to the login page (or home page) using navigate
//       });
//   };

//   const navigateToProfile = () => {
//     navigate('/profile');  // Redirect to the profile page
//   };

//   return (
//     <>
//       <div id="mySidebar" className={`sidebar ${isSidebarClosed ? 'closed' : ''} ${isOpen ? 'open' : ''}`}>
//         <div className="sidebar-header">
//           <img src={ganeshlogo} className="h3" alt="Ganesh Logo" />
//           <button className="toggle-btn" onClick={toggleNav}>
//             <FaOm />
//           </button>
//         </div>



//         {role === "Admin" && (
//           <>
//             <a href="/home"><FontAwesomeIcon icon={faHome} style={{ margin: '10px' }} /> <span>Home</span></a>
//             <a href="/productCategory"><FontAwesomeIcon icon={faChartLine} style={{ margin: '10px' }} /> <span>Product Category</span></a>
//             <a href="/productUnit"><FontAwesomeIcon icon={faBox} style={{ margin: '10px' }} /> <span>Product Unit</span></a>
//             <a href="/poojaManagement"><FontAwesomeIcon icon={faEnvelope} style={{ margin: '10px' }} /> <span>Manage Pooja</span></a>
//             <a href="/user"><FontAwesomeIcon icon={faUser} style={{ margin: '10px' }} /> <span>Users</span></a>
//             <a href="/order"><FontAwesomeIcon icon={faCreditCard} style={{ margin: '10px' }} /> <span>Purchases</span></a>
//             <a href="/poojaBooking"><FontAwesomeIcon icon={faTicketAlt} style={{ margin: '10px' }} /> <span>Pooja Ticket Booking</span></a>
//             <a href="/viewBooking"><FontAwesomeIcon icon={faShoppingCart} style={{ margin: '10px' }} /> <span>View Bookings</span></a>
//             <a href="/purchaseToStoke"><FontAwesomeIcon icon={faBoxOpen} style={{ margin: '10px' }} /> <span>Purchase To Stoke</span></a>
//             <a href="/stockDetails"><FontAwesomeIcon icon={faChartBar} style={{ margin: '10px' }} /> <span>View Stock</span></a>
//             <a href="/stockReport"><FontAwesomeIcon icon={faCog} style={{ margin: '10px' }} /> <span>StockReports</span></a>
//             <a href="/report"><FontAwesomeIcon icon={faCog} style={{ margin: '10px' }} /> <span>Pooja Booking Reports</span></a>

//           </>
//         )}

//         {role === "Operator" && (
//           <> 
//             <a href="/operatorDashboard"><FontAwesomeIcon icon={faHome} style={{ margin: '10px' }} /> <span>Dashboard</span></a>
//        <a href="/order"><FontAwesomeIcon icon={faCreditCard} style={{ margin: '10px' }} /> <span>Purchases</span></a>

//             <a href="/poojaBooking"><FontAwesomeIcon icon={faTicketAlt} style={{ margin: '10px' }} /> <span>Pooja Ticket Booking</span></a>
//             <a href="/viewBooking"><FontAwesomeIcon icon={faShoppingCart} style={{ margin: '10px' }} /> <span>View Bookings</span></a>
//             <a href="/purchaseToStoke"><FontAwesomeIcon icon={faBoxOpen} style={{ margin: '10px' }} /> <span>Purchase To Stoke</span></a>
//             <a href="/stockDetails"><FontAwesomeIcon icon={faChartBar} style={{ margin: '10px' }} /> <span>View Stock</span></a>
//             <a href="/stockReport"><FontAwesomeIcon icon={faCog} style={{ margin: '10px' }} /> <span>StockReports</span></a>
//             <a href="/report"><FontAwesomeIcon icon={faCog} style={{ margin: '10px' }} /> <span>Pooja Booking Reports</span></a>
//           </>
//         )}
//       </div>

//       <div id="main" style={{ position: 'relative' }}>
//         <img src={headertemple} alt="Header" className="HeaderImag" />

//         <div style={{
//           position: 'absolute',
//           top: '10px',
//           right: '20px',
//           zIndex: 10,
//         }}>
//           <Dropdown align="end">
//             <Dropdown.Toggle variant="link" id="dropdown-custom-components">
//               <FaUserCircle size={30} color="#fff" />
//             </Dropdown.Toggle>

//             <Dropdown.Menu>
//               <Dropdown.Item onClick={navigateToProfile}>
//                 <FaUserCircle size={24} /> Profile
//               </Dropdown.Item>
//               <Dropdown.Item onClick={handleLogout}>
//                 <FaSignOutAlt size={24} /> Logout
//               </Dropdown.Item>
//             </Dropdown.Menu>
//           </Dropdown>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Sidebar;


// import React, { useState, useEffect } from "react";
// import headertemple from '../images/headertemple.jpeg';
// import ganeshlogo from '../images/ganeshlogo.jpeg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//   faHome, 
//   faChartLine, 
//   faUser, 
//   faBox, 
//   faCreditCard, 
//   faTicketAlt, 
//   faShoppingCart, 
//   faBoxOpen, 
//   faChartBar, 
//   faFileAlt, 
//   faFire, 
//   faChevronRight,
//   faBars,
//   faTimes
// } from '@fortawesome/free-solid-svg-icons';
// import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
// import { Dropdown } from 'react-bootstrap';
// import swal from 'sweetalert';
// import { useNavigate, useLocation, Link } from 'react-router-dom';

// function Sidebar() {
//   const [role, setRole] = useState(null);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
//   const [isOpenMobile, setIsOpenMobile] = useState(false);
//   const [hoveredIndex, setHoveredIndex] = useState(null);

//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const userRole = sessionStorage.getItem("role") || "Admin"; // Fallback to Admin for preview
//     setRole(userRole);

//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 992);
//       if (window.innerWidth > 992) {
//         setIsOpenMobile(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleLogout = () => {
//     sessionStorage.clear();
//     swal('Logged Out', 'You have been logged out successfully!', 'success')
//       .then(() => {
//         navigate('/');
//       });
//   };

//   const navigateToProfile = () => {
//     navigate('/profile');
//   };

//   // Menu items list
//   const adminMenuItems = [
//     { label: "Home", path: "/home", icon: faHome },
//     { label: "Product Category", path: "/productCategory", icon: faChartLine },
//     { label: "Product Unit", path: "/productUnit", icon: faBox },
//     { label: "Manage Pooja", path: "/poojaManagement", icon: faFire },
//     { label: "Users", path: "/user", icon: faUser },
//     { label: "Purchases", path: "/order", icon: faCreditCard },
//     { label: "Pooja Ticket Booking", path: "/poojaBooking", icon: faTicketAlt },
//     { label: "View Bookings", path: "/viewBooking", icon: faShoppingCart },
//     { label: "Purchase To Stock", path: "/purchaseToStoke", icon: faBoxOpen },
//     { label: "View Stock", path: "/stockDetails", icon: faChartBar },
//     { label: "Stock Reports", path: "/stockReport", icon: faFileAlt },
//     { label: "Pooja Booking Reports", path: "/report", icon: faFileAlt },
//   ];

//   const operatorMenuItems = [
//     { label: "Dashboard", path: "/operatorDashboard", icon: faHome },
//     { label: "Purchases", path: "/order", icon: faCreditCard },
//     { label: "Pooja Ticket Booking", path: "/poojaBooking", icon: faTicketAlt },
//     { label: "View Bookings", path: "/viewBooking", icon: faShoppingCart },
//     { label: "Purchase To Stock", path: "/purchaseToStoke", icon: faBoxOpen },
//     { label: "View Stock", path: "/stockDetails", icon: faChartBar },
//     { label: "Stock Reports", path: "/stockReport", icon: faFileAlt },
//     { label: "Pooja Booking Reports", path: "/report", icon: faFileAlt },
//   ];

//   const currentMenu = role === "Operator" ? operatorMenuItems : adminMenuItems;

//   // --- Inline Style Objects ---
//   const containerStyle = {
//     display: "flex",
//     minHeight: "100vh",
//     width: "100%",
//     backgroundColor: "#faf5ee",
//     position: "relative",
//     overflowX: "hidden",
//     fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
//   };

//   const sidebarStyle = {
//     width: isMobile ? "280px" : "260px",
//     minWidth: isMobile ? "280px" : "260px",
//     backgroundColor: "#5c1d11",
//     color: "#f3ded2",
//     display: "flex",
//     flexDirection: "column",
//     height: "100vh",
//     position: isMobile ? "fixed" : "sticky",
//     top: 0,
//     left: isMobile ? (isOpenMobile ? "0" : "-300px") : "0",
//     zIndex: 1050,
//     transition: "left 0.3s ease",
//     boxShadow: "4px 0 16px rgba(0,0,0,0.15)",
//     overflowY: "auto",
//     padding: "16px 12px",
//     boxSizing: "border-box"
//   };

//   const logoContainerStyle = {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     padding: "8px 12px 24px 12px",
//     borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
//     marginBottom: "12px"
//   };

//   const logoBadgeStyle = {
//     width: "40px",
//     height: "40px",
//     borderRadius: "10px",
//     backgroundColor: "#e65100",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#fff",
//     fontSize: "20px",
//     flexShrink: 0,
//     overflow: "hidden"
//   };

//   const navListStyle = {
//     display: "flex",
//     flexDirection: "column",
//     gap: "4px",
//     flexGrow: 1
//   };

//   const getMenuItemStyle = (isActive, isHovered) => ({
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     padding: "11px 16px",
//     borderRadius: "10px",
//     textDecoration: "none",
//     fontSize: "14px",
//     fontWeight: isActive ? "600" : "400",
//     color: isActive ? "#ffffff" : isHovered ? "#ffffff" : "#d9b8b0",
//     backgroundColor: isActive 
//       ? "#e65100" 
//       : isHovered 
//       ? "rgba(255, 255, 255, 0.07)" 
//       : "transparent",
//     transition: "all 0.2s ease",
//     cursor: "pointer",
//     boxShadow: isActive ? "0 4px 12px rgba(230, 81, 0, 0.3)" : "none"
//   });

//   const overlayStyle = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100vw",
//     height: "100vh",
//     backgroundColor: "rgba(0,0,0,0.5)",
//     zIndex: 1040,
//     display: isMobile && isOpenMobile ? "block" : "none"
//   };

//   const mainContentStyle = {
//     flexGrow: 1,
//     minWidth: 0,
//     display: "flex",
//     flexDirection: "column"
//   };

//   return (
//     <div style={containerStyle}>
//       {/* Mobile Dark Backdrop */}
//       <div style={overlayStyle} onClick={() => setIsOpenMobile(false)} />

//       {/* Sidebar Navigation */}
//       <aside style={sidebarStyle}>
//         {/* Header / Logo */}
//         <div style={logoContainerStyle}>
//           <div style={logoBadgeStyle}>
//             {ganeshlogo ? (
//               <img src={ganeshlogo} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//             ) : (
//               <FontAwesomeIcon icon={faFire} />
//             )}
//           </div>
//           <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
//             <span style={{ color: "#fff", fontWeight: "700", fontSize: "15px", letterSpacing: "0.5px" }}>POOJA SEVA</span>
//             <span style={{ color: "#d9b8b0", fontSize: "11px" }}>Temple Management</span>
//           </div>
//         </div>

//         {/* Navigation Items */}
//         <div style={navListStyle}>
//           {currentMenu.map((item, index) => {
//             const isActive = location.pathname === item.path || (item.path === "/home" && location.pathname === "/");
//             const isHovered = hoveredIndex === index;

//             return (
//               <Link
//                 key={item.path}
//                 to={item.path}
//                 style={getMenuItemStyle(isActive, isHovered)}
//                 onMouseEnter={() => setHoveredIndex(index)}
//                 onMouseLeave={() => setHoveredIndex(null)}
//                 onClick={() => isMobile && setIsOpenMobile(false)}
//               >
//                 <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//                   <FontAwesomeIcon 
//                     icon={item.icon} 
//                     style={{ 
//                       width: "18px", 
//                       fontSize: "16px",
//                       color: isActive ? "#ffffff" : isHovered ? "#ffffff" : "#d9b8b0"
//                     }} 
//                   />
//                   <span>{item.label}</span>
//                 </div>
//                 {isActive && (
//                   <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: "12px" }} />
//                 )}
//               </Link>
//             );
//           })}
//         </div>

//         {/* Sign Out Button at the bottom */}
//         <div style={{ borderTop: "1px solid rgba(255, 255, 255, 0.08)", paddingTop: "12px", marginTop: "auto" }}>
//           <div
//             style={getMenuItemStyle(false, hoveredIndex === "logout")}
//             onMouseEnter={() => setHoveredIndex("logout")}
//             onMouseLeave={() => setHoveredIndex(null)}
//             onClick={handleLogout}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <FaSignOutAlt style={{ fontSize: "16px", width: "18px" }} />
//               <span>Sign Out</span>
//             </div>
//           </div>
//         </div>
//       </aside>

//       {/* Main Content Area */}
//       <div style={mainContentStyle}>
//         {/* Mobile Header Trigger */}
//         {isMobile && (
//           <header style={{
//             height: "56px",
//             backgroundColor: "#5c1d11",
//             display: "flex",
//             alignItems: "center",
//             padding: "0 16px",
//             color: "#fff",
//             gap: "14px"
//           }}>
//             <button 
//               onClick={() => setIsOpenMobile(!isOpenMobile)}
//               style={{
//                 background: "transparent",
//                 border: "none",
//                 color: "#fff",
//                 fontSize: "20px",
//                 cursor: "pointer",
//                 padding: "4px"
//               }}
//             >
//               <FontAwesomeIcon icon={isOpenMobile ? faTimes : faBars} />
//             </button>
//             <span style={{ fontWeight: "600", fontSize: "16px" }}>POOJA SEVA</span>
//           </header>
//         )}

//         {/* Desktop Header Image Banner & Topbar */}
//         <div id="main" style={{ position: 'relative', width: "100%" }}>
//           <img 
//             src={headertemple} 
//             alt="Header" 
//             style={{ 
//               width: "100%", 
//               height: isMobile ? "80px" : "120px", 
//               objectFit: "cover",
//               display: "block" 
//             }} 
//           />

//           <div style={{
//             position: 'absolute',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             right: '24px',
//             zIndex: 10,
//           }}>
//             <Dropdown align="end">
//               <Dropdown.Toggle 
//                 variant="link" 
//                 id="dropdown-custom-components" 
//                 style={{ 
//                   textDecoration: "none", 
//                   boxShadow: "none", 
//                   padding: 0,
//                   display: "flex",
//                   alignItems: "center"
//                 }}
//               >
//                 <FaUserCircle size={34} color="#fff" style={{ filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.4))" }} />
//               </Dropdown.Toggle>

//               <Dropdown.Menu style={{ borderRadius: "8px", boxShadow: "0 8px 24px rgba(0,0,0,0.15)", border: "none" }}>
//                 <Dropdown.Item onClick={navigateToProfile} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 16px" }}>
//                   <FaUserCircle size={18} color="#5c1d11" /> Profile
//                 </Dropdown.Item>
//                 <Dropdown.Divider />
//                 <Dropdown.Item onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 16px", color: "#d9534f" }}>
//                   <FaSignOutAlt size={18} /> Logout
//                 </Dropdown.Item>
//               </Dropdown.Menu>
//             </Dropdown>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Sidebar;



// import React, { useState, useEffect } from "react";
// import headertemple from '../images/headertemple.jpeg';
// import ganeshlogo from '../images/ganeshlogo.jpeg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//   faHome, 
//   faChartLine, 
//   faUser, 
//   faBox, 
//   faCreditCard, 
//   faTicketAlt, 
//   faShoppingCart, 
//   faBoxOpen, 
//   faChartBar, 
//   faFileAlt, 
//   faFire, 
//   faChevronRight,
//   faBars,
//   faTimes
// } from '@fortawesome/free-solid-svg-icons';
// import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
// import { Dropdown } from 'react-bootstrap';
// import swal from 'sweetalert';
// import { useNavigate, useLocation, Link } from 'react-router-dom';

// function Sidebar() {
//   const [role, setRole] = useState(null);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
//   const [isOpenMobile, setIsOpenMobile] = useState(false);
//   const [hoveredIndex, setHoveredIndex] = useState(null);

//   const navigate = useNavigate();
//   const location = useLocation();

//   const SIDEBAR_WIDTH = 260;

//   useEffect(() => {
//     const userRole = sessionStorage.getItem("role") || "Admin";
//     setRole(userRole);

//     const handleResize = () => {
//       const mobile = window.innerWidth <= 992;
//       setIsMobile(mobile);
//       if (!mobile) setIsOpenMobile(false);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Syncs page body background and margins so your HomeScreen sits flush to the right of the fixed sidebar
//   useEffect(() => {
//     document.body.style.backgroundColor = "#faf5ee";
//     document.body.style.margin = "0";
//     document.body.style.padding = "0";

//     const updateBodyMargin = () => {
//       if (window.innerWidth > 992) {
//         document.body.style.marginLeft = `${SIDEBAR_WIDTH}px`;
//       } else {
//         document.body.style.marginLeft = "0px";
//       }
//     };

//     updateBodyMargin();
//     window.addEventListener("resize", updateBodyMargin);

//     return () => {
//       document.body.style.marginLeft = "0px";
//       window.removeEventListener("resize", updateBodyMargin);
//     };
//   }, []);

//   const handleLogout = () => {
//     sessionStorage.clear();
//     swal('Logged Out', 'You have been logged out successfully!', 'success')
//       .then(() => {
//         navigate('/');
//       });
//   };

//   const navigateToProfile = () => {
//     navigate('/profile');
//   };

//   const adminMenuItems = [
//     { label: "Home", path: "/home", icon: faHome },
//     { label: "Product Category", path: "/productCategory", icon: faChartLine },
//     { label: "Product Unit", path: "/productUnit", icon: faBox },
//     { label: "Manage Pooja", path: "/poojaManagement", icon: faFire },
//     { label: "Users", path: "/user", icon: faUser },
//     { label: "Purchases", path: "/order", icon: faCreditCard },
//     { label: "Pooja Ticket Booking", path: "/poojaBooking", icon: faTicketAlt },
//     { label: "View Bookings", path: "/viewBooking", icon: faShoppingCart },
//     { label: "Purchase To Stock", path: "/purchaseToStoke", icon: faBoxOpen },
//     { label: "View Stock", path: "/stockDetails", icon: faChartBar },
//     { label: "Stock Reports", path: "/stockReport", icon: faFileAlt },
//     { label: "Pooja Booking Reports", path: "/report", icon: faFileAlt },
//   ];

//   const operatorMenuItems = [
//     { label: "Dashboard", path: "/operatorDashboard", icon: faHome },
//     { label: "Purchases", path: "/order", icon: faCreditCard },
//     { label: "Pooja Ticket Booking", path: "/poojaBooking", icon: faTicketAlt },
//     { label: "View Bookings", path: "/viewBooking", icon: faShoppingCart },
//     { label: "Purchase To Stock", path: "/purchaseToStoke", icon: faBoxOpen },
//     { label: "View Stock", path: "/stockDetails", icon: faChartBar },
//     { label: "Stock Reports", path: "/stockReport", icon: faFileAlt },
//     { label: "Pooja Booking Reports", path: "/report", icon: faFileAlt },
//   ];

//   const currentMenu = role === "Operator" ? operatorMenuItems : adminMenuItems;

//   const sidebarStyle = {
//     position: "fixed",
//     top: 0,
//     left: isMobile ? (isOpenMobile ? 0 : `-${SIDEBAR_WIDTH + 20}px`) : 0,
//     width: `${SIDEBAR_WIDTH}px`,
//     height: "100vh",
//     backgroundColor: "#5c1d11",
//     color: "#f3ded2",
//     display: "flex",
//     flexDirection: "column",
//     zIndex: 1050,
//     transition: "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//     boxShadow: "4px 0 16px rgba(0,0,0,0.15)",
//     overflowY: "auto",
//     padding: "16px 12px",
//     boxSizing: "border-box",
//     fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
//   };

//   const getMenuItemStyle = (isActive, isHovered) => ({
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     padding: "11px 16px",
//     borderRadius: "10px",
//     textDecoration: "none",
//     fontSize: "14px",
//     fontWeight: isActive ? "600" : "400",
//     color: isActive ? "#ffffff" : isHovered ? "#ffffff" : "#d9b8b0",
//     backgroundColor: isActive 
//       ? "#e65100" 
//       : isHovered 
//       ? "rgba(255, 255, 255, 0.08)" 
//       : "transparent",
//     transition: "all 0.2s ease",
//     cursor: "pointer",
//     boxShadow: isActive ? "0 4px 12px rgba(230, 81, 0, 0.3)" : "none",
//     boxSizing: "border-box"
//   });

//   return (
//     <>
//       {/* Mobile Overlay */}
//       {isMobile && isOpenMobile && (
//         <div 
//           onClick={() => setIsOpenMobile(false)}
//           style={{
//             position: "fixed",
//             inset: 0,
//             backgroundColor: "rgba(0,0,0,0.5)",
//             zIndex: 1040
//           }} 
//         />
//       )}

//       {/* Fixed Left Sidebar */}
//       <aside style={sidebarStyle}>
//         {/* Header / Logo */}
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "12px",
//           padding: "8px 12px 20px 12px",
//           borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
//           marginBottom: "12px",
//           flexShrink: 0
//         }}>
//           <div style={{
//             width: "40px",
//             height: "40px",
//             borderRadius: "10px",
//             backgroundColor: "#e65100",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "#fff",
//             fontSize: "20px",
//             flexShrink: 0,
//             overflow: "hidden"
//           }}>
//             {ganeshlogo ? (
//               <img src={ganeshlogo} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//             ) : (
//               <FontAwesomeIcon icon={faFire} />
//             )}
//           </div>
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <span style={{ color: "#fff", fontWeight: "700", fontSize: "15px", letterSpacing: "0.5px" }}>POOJA SEVA</span>
//             <span style={{ color: "#d9b8b0", fontSize: "11px" }}>Temple Management</span>
//           </div>
//         </div>

//         {/* Menu Items */}
//         <div style={{ display: "flex", flexDirection: "column", gap: "4px", flexGrow: 1 }}>
//           {currentMenu.map((item, index) => {
//             const isActive = location.pathname === item.path || (item.path === "/home" && location.pathname === "/");
//             const isHovered = hoveredIndex === index;

//             return (
//               <Link
//                 key={item.path}
//                 to={item.path}
//                 style={getMenuItemStyle(isActive, isHovered)}
//                 onMouseEnter={() => setHoveredIndex(index)}
//                 onMouseLeave={() => setHoveredIndex(null)}
//                 onClick={() => isMobile && setIsOpenMobile(false)}
//               >
//                 <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//                   <FontAwesomeIcon 
//                     icon={item.icon} 
//                     style={{ width: "18px", fontSize: "16px", color: isActive || isHovered ? "#fff" : "#d9b8b0" }} 
//                   />
//                   <span>{item.label}</span>
//                 </div>
//                 {isActive && <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: "12px" }} />}
//               </Link>
//             );
//           })}
//         </div>

//         {/* Sign Out Button */}
//         <div style={{ borderTop: "1px solid rgba(255, 255, 255, 0.08)", paddingTop: "12px", marginTop: "auto", flexShrink: 0 }}>
//           <div
//             style={getMenuItemStyle(false, hoveredIndex === "logout")}
//             onMouseEnter={() => setHoveredIndex("logout")}
//             onMouseLeave={() => setHoveredIndex(null)}
//             onClick={handleLogout}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <FaSignOutAlt style={{ fontSize: "16px", width: "18px" }} />
//               <span>Sign Out</span>
//             </div>
//           </div>
//         </div>
//       </aside>

//       {/* Top Banner Header */}
//       <div style={{ width: "100%", position: "relative", boxSizing: "border-box" }}>
//         {isMobile && (
//           <header style={{
//             height: "56px",
//             backgroundColor: "#5c1d11",
//             display: "flex",
//             alignItems: "center",
//             padding: "0 16px",
//             color: "#fff",
//             gap: "14px"
//           }}>
//             <button 
//               onClick={() => setIsOpenMobile(!isOpenMobile)}
//               style={{
//                 background: "transparent",
//                 border: "none",
//                 color: "#fff",
//                 fontSize: "20px",
//                 cursor: "pointer",
//                 padding: "4px"
//               }}
//             >
//               <FontAwesomeIcon icon={isOpenMobile ? faTimes : faBars} />
//             </button>
//             <span style={{ fontWeight: "600", fontSize: "16px" }}>POOJA SEVA</span>
//           </header>
//         )}

//         <div style={{ position: 'relative', width: "100%", height: isMobile ? "75px" : "100px", overflow: "hidden" }}>
//           {/* <img 
//             src={headertemple} 
//             alt="Header" 
//             style={{ 
//               width: "100%", 
//               height: "100%", 
//               objectFit: "cover",
//               display: "block" 
//             }} 
//           /> */}

//           <div style={{
//             position: 'absolute',
//             top: '50%',
//             transform: 'translateY(-50%)',
//             right: '24px',
//             zIndex: 10,
//           }}>
//             <Dropdown align="end">
//               <Dropdown.Toggle 
//                 variant="link" 
//                 id="dropdown-custom-components" 
//                 style={{ textDecoration: "none", boxShadow: "none", padding: 0, border: "none" }}
//               >
//                 <FaUserCircle size={34} color="#fff" style={{ filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.4))" }} />
//               </Dropdown.Toggle>

//               <Dropdown.Menu style={{ borderRadius: "8px", boxShadow: "0 8px 24px rgba(0,0,0,0.15)", border: "none" }}>
//                 <Dropdown.Item onClick={navigateToProfile} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 16px" }}>
//                   <FaUserCircle size={18} color="#5c1d11" /> Profile
//                 </Dropdown.Item>
//                 <Dropdown.Divider />
//                 <Dropdown.Item onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 16px", color: "#d9534f" }}>
//                   <FaSignOutAlt size={18} /> Logout
//                 </Dropdown.Item>
//               </Dropdown.Menu>
//             </Dropdown>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default Sidebar;


// import React, { useState, useEffect } from "react";
// import ganeshlogo from '../images/ganeshlogo.jpeg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { 
//   faHome, 
//   faChartLine, 
//   faUser, 
//   faBox, 
//   faCreditCard, 
//   faTicketAlt, 
//   faShoppingCart, 
//   faBoxOpen, 
//   faChartBar, 
//   faFileAlt, 
//   faFire, 
//   faChevronRight,
//   faBars,
//   faTimes,
//   faBell
// } from '@fortawesome/free-solid-svg-icons';
// import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
// import { Dropdown } from 'react-bootstrap';
// import swal from 'sweetalert';
// import { useNavigate, useLocation, Link } from 'react-router-dom';

// function Sidebar() {
//   const [role, setRole] = useState(null);
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
//   const [isOpenMobile, setIsOpenMobile] = useState(false);
//   const [hoveredIndex, setHoveredIndex] = useState(null);

//   const navigate = useNavigate();
//   const location = useLocation();

//   const EXPANDED_WIDTH = 260;
//   const COLLAPSED_WIDTH = 76;
//   const currentSidebarWidth = isMobile ? EXPANDED_WIDTH : (isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH);

//   useEffect(() => {
//     const userRole = sessionStorage.getItem("role") || "Admin";
//     setRole(userRole);

//     const handleResize = () => {
//       const mobile = window.innerWidth <= 992;
//       setIsMobile(mobile);
//       if (!mobile) setIsOpenMobile(false);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Synchronizes the body margin and background so HomeScreen aligns side-by-side
//   useEffect(() => {
//     document.body.style.backgroundColor = "#faf5ee";
//     document.body.style.margin = "0";
//     document.body.style.padding = "0";

//     const updateBodyLayout = () => {
//       if (window.innerWidth > 992) {
//         document.body.style.marginLeft = `${isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH}px`;
//       } else {
//         document.body.style.marginLeft = "0px";
//       }
//     };

//     updateBodyLayout();
//     window.addEventListener("resize", updateBodyLayout);

//     return () => {
//       document.body.style.marginLeft = "0px";
//       window.removeEventListener("resize", updateBodyLayout);
//     };
//   }, [isCollapsed, isMobile]);

//   const handleLogout = () => {
//     sessionStorage.clear();
//     swal('Logged Out', 'You have been logged out successfully!', 'success')
//       .then(() => {
//         navigate('/');
//       });
//   };

//   const navigateToProfile = () => {
//     navigate('/profile');
//   };

//   const toggleSidebar = () => {
//     if (isMobile) {
//       setIsOpenMobile(!isOpenMobile);
//     } else {
//       setIsCollapsed(!isCollapsed);
//     }
//   };

//   const adminMenuItems = [
//     { label: "Home", path: "/home", icon: faHome },
//     { label: "Product Category", path: "/productCategory", icon: faChartLine },
//     { label: "Product Unit", path: "/productUnit", icon: faBox },
//     { label: "Manage Pooja", path: "/poojaManagement", icon: faFire },
//     { label: "Users", path: "/user", icon: faUser },
//     { label: "Purchases", path: "/order", icon: faCreditCard },
//     { label: "Pooja Ticket Booking", path: "/poojaBooking", icon: faTicketAlt },
//     { label: "View Bookings", path: "/viewBooking", icon: faShoppingCart },
//     { label: "Purchase To Stock", path: "/purchaseToStoke", icon: faBoxOpen },
//     { label: "View Stock", path: "/stockDetails", icon: faChartBar },
//     { label: "Stock Reports", path: "/stockReport", icon: faFileAlt },
//     { label: "Pooja Booking Reports", path: "/report", icon: faFileAlt },
//   ];

//   const operatorMenuItems = [
//     { label: "Dashboard", path: "/operatorDashboard", icon: faHome },
//     { label: "Purchases", path: "/order", icon: faCreditCard },
//     { label: "Pooja Ticket Booking", path: "/poojaBooking", icon: faTicketAlt },
//     { label: "View Bookings", path: "/viewBooking", icon: faShoppingCart },
//     { label: "Purchase To Stock", path: "/purchaseToStoke", icon: faBoxOpen },
//     { label: "View Stock", path: "/stockDetails", icon: faChartBar },
//     { label: "Stock Reports", path: "/stockReport", icon: faFileAlt },
//     { label: "Pooja Booking Reports", path: "/report", icon: faFileAlt },
//   ];

//   const currentMenu = role === "Operator" ? operatorMenuItems : adminMenuItems;

//   // Sidebar container styles
//   const sidebarStyle = {
//     position: "fixed",
//     top: 0,
//     left: isMobile ? (isOpenMobile ? 0 : `-${EXPANDED_WIDTH + 20}px`) : 0,
//     width: `${currentSidebarWidth}px`,
//     height: "100vh",
//     backgroundColor: "#5c1d11",
//     color: "#f3ded2",
//     display: "flex",
//     flexDirection: "column",
//     zIndex: 1050,
//     transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//     boxShadow: "4px 0 16px rgba(0,0,0,0.12)",
//     overflowY: "auto",
//     overflowX: "hidden",
//     padding: isCollapsed && !isMobile ? "16px 8px" : "16px 12px",
//     boxSizing: "border-box",
//     fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
//   };

//   const getMenuItemStyle = (isActive, isHovered) => ({
//     display: "flex",
//     alignItems: "center",
//     justifyContent: isCollapsed && !isMobile ? "center" : "space-between",
//     padding: isCollapsed && !isMobile ? "12px 0" : "11px 16px",
//     borderRadius: "10px",
//     textDecoration: "none",
//     fontSize: "14px",
//     fontWeight: isActive ? "600" : "400",
//     color: isActive ? "#ffffff" : isHovered ? "#ffffff" : "#d9b8b0",
//     backgroundColor: isActive 
//       ? "#e65100" 
//       : isHovered 
//       ? "rgba(255, 255, 255, 0.08)" 
//       : "transparent",
//     transition: "all 0.2s ease",
//     cursor: "pointer",
//     boxShadow: isActive ? "0 4px 12px rgba(230, 81, 0, 0.3)" : "none",
//     boxSizing: "border-box",
//     whiteSpace: "nowrap"
//   });

//   return (
//     <>
//       {/* Mobile Dark Overlay */}
//       {isMobile && isOpenMobile && (
//         <div 
//           onClick={() => setIsOpenMobile(false)}
//           style={{
//             position: "fixed",
//             inset: 0,
//             backgroundColor: "rgba(0,0,0,0.5)",
//             zIndex: 1040
//           }} 
//         />
//       )}

//       {/* Fixed Sidebar */}
//       <aside style={sidebarStyle}>
//         {/* Logo Section */}
//         <div style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "12px",
//           padding: isCollapsed && !isMobile ? "8px 0 20px 0" : "8px 12px 20px 12px",
//           justifyContent: isCollapsed && !isMobile ? "center" : "flex-start",
//           borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
//           marginBottom: "12px",
//           flexShrink: 0
//         }}>
//           <div style={{
//             width: "40px",
//             height: "40px",
//             borderRadius: "10px",
//             backgroundColor: "#e65100",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "#fff",
//             fontSize: "20px",
//             flexShrink: 0,
//             overflow: "hidden"
//           }}>
//             {ganeshlogo ? (
//               <img src={ganeshlogo} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
//             ) : (
//               <FontAwesomeIcon icon={faFire} />
//             )}
//           </div>
//           {(!isCollapsed || isMobile) && (
//             <div style={{ display: "flex", flexDirection: "column" }}>
//               <span style={{ color: "#fff", fontWeight: "700", fontSize: "15px", letterSpacing: "0.5px" }}>POOJA SEVA</span>
//               <span style={{ color: "#d9b8b0", fontSize: "11px" }}>Temple Management</span>
//             </div>
//           )}
//         </div>

//         {/* Navigation Items */}
//         <div style={{ display: "flex", flexDirection: "column", gap: "4px", flexGrow: 1 }}>
//           {currentMenu.map((item, index) => {
//             const isActive = location.pathname === item.path || (item.path === "/home" && location.pathname === "/");
//             const isHovered = hoveredIndex === index;

//             return (
//               <Link
//                 key={item.path}
//                 to={item.path}
//                 title={isCollapsed && !isMobile ? item.label : ""}
//                 style={getMenuItemStyle(isActive, isHovered)}
//                 onMouseEnter={() => setHoveredIndex(index)}
//                 onMouseLeave={() => setHoveredIndex(null)}
//                 onClick={() => isMobile && setIsOpenMobile(false)}
//               >
//                 <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//                   <FontAwesomeIcon 
//                     icon={item.icon} 
//                     style={{ 
//                       width: "18px", 
//                       fontSize: "16px", 
//                       color: isActive || isHovered ? "#fff" : "#d9b8b0" 
//                     }} 
//                   />
//                   {(!isCollapsed || isMobile) && <span>{item.label}</span>}
//                 </div>
//                 {isActive && (!isCollapsed || isMobile) && (
//                   <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: "12px" }} />
//                 )}
//               </Link>
//             );
//           })}
//         </div>

//         {/* Sign Out Button */}
//         <div style={{ borderTop: "1px solid rgba(255, 255, 255, 0.08)", paddingTop: "12px", marginTop: "auto", flexShrink: 0 }}>
//           <div
//             style={getMenuItemStyle(false, hoveredIndex === "logout")}
//             onMouseEnter={() => setHoveredIndex("logout")}
//             onMouseLeave={() => setHoveredIndex(null)}
//             onClick={handleLogout}
//             title={isCollapsed && !isMobile ? "Sign Out" : ""}
//           >
//             <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
//               <FaSignOutAlt style={{ fontSize: "16px", width: "18px" }} />
//               {(!isCollapsed || isMobile) && <span>Sign Out</span>}
//             </div>
//           </div>
//         </div>
//       </aside>

//       {/* Top Header Bar */}
//       <header style={{
//         height: "64px",
//         backgroundColor: "#ffffff",
//         borderBottom: "1px solid #ffedd5",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//         padding: "0 24px",
//         boxSizing: "border-box",
//         position: "sticky",
//         top: 0,
//         zIndex: 1000,
//         boxShadow: "0 1px 3px rgba(0,0,0,0.02)"
//       }}>
//         {/* Left: Collapse Button + Page Title */}
//         <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//           <button
//             onClick={toggleSidebar}
//             style={{
//               width: "36px",
//               height: "36px",
//               borderRadius: "8px",
//               border: "1px solid #ffedd5",
//               backgroundColor: "#fff7ed",
//               color: "#5c1d11",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               cursor: "pointer",
//               fontSize: "15px",
//               outline: "none",
//               transition: "all 0.2s ease"
//             }}
//           >
//             <FontAwesomeIcon icon={isMobile ? (isOpenMobile ? faTimes : faBars) : (isCollapsed ? faBars : faTimes)} />
//           </button>

//           <div>
//             <h1 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#111827", lineHeight: "1.2" }}>
//               Home
//             </h1>
//             <p style={{ margin: 0, fontSize: "12px", color: "#9ca3af" }}>
//               Temple Management System
//             </p>
//           </div>
//         </div>

//         {/* Right: Notifications & User Profile */}
//         <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
//           {/* Notification Bell */}
//           <div style={{ position: "relative", cursor: "pointer", display: "flex", alignItems: "center" }}>
//             <FontAwesomeIcon icon={faBell} style={{ fontSize: "18px", color: "#6b7280" }} />
//             <span style={{
//               position: "absolute",
//               top: "-2px",
//               right: "-2px",
//               width: "8px",
//               height: "8px",
//               backgroundColor: "#ea580c",
//               borderRadius: "50%",
//               border: "2px solid #ffffff"
//             }} />
//           </div>

//           {/* User Profile Pill & Dropdown */}
//           <Dropdown align="end">
//             <Dropdown.Toggle
//               as="div"
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "10px",
//                 cursor: "pointer",
//                 padding: "4px 8px",
//                 borderRadius: "24px",
//                 transition: "background 0.2s"
//               }}
//             >
//               <div style={{
//                 width: "36px",
//                 height: "36px",
//                 borderRadius: "50%",
//                 backgroundColor: "#ea580c",
//                 color: "#ffffff",
//                 fontWeight: "700",
//                 fontSize: "13px",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center"
//               }}>
//                 SK
//               </div>
//               <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
//                 <span style={{ fontSize: "13px", fontWeight: "600", color: "#111827", lineHeight: "1.2" }}>
//                   Swami Krishnadas
//                 </span>
//                 <span style={{ fontSize: "11px", color: "#6b7280" }}>
//                   Super Admin
//                 </span>
//               </div>
//             </Dropdown.Toggle>

//             <Dropdown.Menu style={{ borderRadius: "10px", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", border: "1px solid #ffedd5" }}>
//               <Dropdown.Item onClick={navigateToProfile} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 16px" }}>
//                 <FaUserCircle size={16} color="#5c1d11" /> Profile
//               </Dropdown.Item>
//               <Dropdown.Divider />
//               <Dropdown.Item onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 16px", color: "#dc2626" }}>
//                 <FaSignOutAlt size={16} /> Logout
//               </Dropdown.Item>
//             </Dropdown.Menu>
//           </Dropdown>
//         </div>
//       </header>
//     </>
//   );
// }

// export default Sidebar;


import React, { useState, useEffect } from "react";
import ganeshlogo from '../images/ganeshlogo.jpeg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, 
  faChartLine, 
  faUser, 
  faBox, 
  faCreditCard, 
  faTicketAlt, 
  faShoppingCart, 
  faBoxOpen, 
  faChartBar, 
  faFileAlt, 
  faFire, 
  faChevronRight,
  faBars,
  faTimes,
  faBell
} from '@fortawesome/free-solid-svg-icons';
import { FaUserCircle, FaSignOutAlt } from "react-icons/fa";
import { Dropdown } from 'react-bootstrap';
import swal from 'sweetalert';
import { useNavigate, useLocation, Link } from 'react-router-dom';

function Sidebar() {
  const [role, setRole] = useState("Admin");
  const [userName, setUserName] = useState("Swami Krishnadas");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [isOpenMobile, setIsOpenMobile] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const EXPANDED_WIDTH = 260;
  const COLLAPSED_WIDTH = 76;
  const currentSidebarWidth = isMobile ? EXPANDED_WIDTH : (isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH);

  useEffect(() => {
    // Read dynamic user info from sessionStorage
    const storedRole = sessionStorage.getItem("role") || "Admin";
    const storedUser = sessionStorage.getItem("username") || sessionStorage.getItem("name") || "Swami Krishnadas";
    setRole(storedRole);
    setUserName(storedUser);

    const handleResize = () => {
      const mobile = window.innerWidth <= 992;
      setIsMobile(mobile);
      if (!mobile) setIsOpenMobile(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Syncs page body margin so page content sits beside sidebar
  useEffect(() => {
    document.body.style.backgroundColor = "#faf5ee";
    document.body.style.margin = "0";
    document.body.style.padding = "0";

    const updateBodyLayout = () => {
      if (window.innerWidth > 992) {
        document.body.style.marginLeft = `${isCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH}px`;
      } else {
        document.body.style.marginLeft = "0px";
      }
    };

    updateBodyLayout();
    window.addEventListener("resize", updateBodyLayout);

    return () => {
      document.body.style.marginLeft = "0px";
      window.removeEventListener("resize", updateBodyLayout);
    };
  }, [isCollapsed, isMobile]);

  const handleLogout = () => {
    sessionStorage.clear();
    swal('Logged Out', 'You have been logged out successfully!', 'success')
      .then(() => {
        navigate('/');
      });
  };

  const navigateToProfile = () => {
    navigate('/profile');
  };

  const toggleSidebar = () => {
    if (isMobile) {
      setIsOpenMobile(!isOpenMobile);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };

  // Helper to generate 2-letter avatar initials
  const getInitials = (name) => {
    if (!name) return "SK";
    const parts = name.trim().split(" ");
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  };

  const adminMenuItems = [
    { label: "Home", path: "/home", icon: faHome },
    { label: "Product Category", path: "/productCategory", icon: faChartLine },
    { label: "Product Unit", path: "/productUnit", icon: faBox },
    { label: "Manage Pooja", path: "/poojaManagement", icon: faFire },
    { label: "Users", path: "/user", icon: faUser },
    { label: "Purchases", path: "/order", icon: faCreditCard },
    { label: "Pooja Ticket Booking", path: "/poojaBooking", icon: faTicketAlt },
    { label: "View Bookings", path: "/viewBooking", icon: faShoppingCart },
    { label: "Purchase To Stock", path: "/purchaseToStoke", icon: faBoxOpen },
    { label: "View Stock", path: "/stockDetails", icon: faChartBar },
    { label: "Stock Reports", path: "/stockReport", icon: faFileAlt },
    { label: "Pooja Booking Reports", path: "/report", icon: faFileAlt },
  ];

  const operatorMenuItems = [
    { label: "Dashboard", path: "/operatorDashboard", icon: faHome },
    { label: "Purchases", path: "/order", icon: faCreditCard },
    { label: "Pooja Ticket Booking", path: "/poojaBooking", icon: faTicketAlt },
    { label: "View Bookings", path: "/viewBooking", icon: faShoppingCart },
    { label: "Purchase To Stock", path: "/purchaseToStoke", icon: faBoxOpen },
    { label: "View Stock", path: "/stockDetails", icon: faChartBar },
    { label: "Stock Reports", path: "/stockReport", icon: faFileAlt },
    { label: "Pooja Booking Reports", path: "/report", icon: faFileAlt },
  ];

  const currentMenu = role === "Operator" ? operatorMenuItems : adminMenuItems;

  // Dynamically derive current page title based on URL route
  const getCurrentPageTitle = () => {
    const currentItem = currentMenu.find((item) => item.path === location.pathname);
    if (currentItem) return currentItem.label;
    if (location.pathname === "/" || location.pathname === "/home") return "Home";
    if (location.pathname === "/profile") return "Profile";
    
    // Fallback: format "/productUnit" -> "Product Unit"
    const cleaned = location.pathname.replace("/", "").replace(/([A-Z])/g, " $1").trim();
    return cleaned ? cleaned.charAt(0).toUpperCase() + cleaned.slice(1) : "Home";
  };

  const sidebarStyle = {
    position: "fixed",
    top: 0,
    left: isMobile ? (isOpenMobile ? 0 : `-${EXPANDED_WIDTH + 20}px`) : 0,
    width: `${currentSidebarWidth}px`,
    height: "100vh",
    backgroundColor: "#5c1d11",
    color: "#f3ded2",
    display: "flex",
    flexDirection: "column",
    zIndex: 1050,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    boxShadow: "4px 0 16px rgba(0,0,0,0.12)",
    overflowY: "auto",
    overflowX: "hidden",
    padding: isCollapsed && !isMobile ? "16px 8px" : "16px 12px",
    boxSizing: "border-box",
    fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
  };

  const getMenuItemStyle = (isActive, isHovered) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: isCollapsed && !isMobile ? "center" : "space-between",
    padding: isCollapsed && !isMobile ? "12px 0" : "11px 16px",
    borderRadius: "10px",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: isActive ? "600" : "400",
    color: isActive ? "#ffffff" : isHovered ? "#ffffff" : "#d9b8b0",
    backgroundColor: isActive 
      ? "#e65100" 
      : isHovered 
      ? "rgba(255, 255, 255, 0.08)" 
      : "transparent",
    transition: "all 0.2s ease",
    cursor: "pointer",
    boxShadow: isActive ? "0 4px 12px rgba(230, 81, 0, 0.3)" : "none",
    boxSizing: "border-box",
    whiteSpace: "nowrap"
  });

  return (
    <>
      {/* Mobile Dark Backdrop */}
      {isMobile && isOpenMobile && (
        <div 
          onClick={() => setIsOpenMobile(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1040
          }} 
        />
      )}

      {/* Fixed Sidebar */}
      <aside style={sidebarStyle}>
        {/* Logo Section */}
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: isCollapsed && !isMobile ? "8px 0 20px 0" : "8px 12px 20px 12px",
          justifyContent: isCollapsed && !isMobile ? "center" : "flex-start",
          borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
          marginBottom: "12px",
          flexShrink: 0
        }}>
          <div style={{
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            backgroundColor: "#e65100",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "20px",
            flexShrink: 0,
            overflow: "hidden"
          }}>
            {ganeshlogo ? (
              <img src={ganeshlogo} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            ) : (
              <FontAwesomeIcon icon={faFire} />
            )}
          </div>
          {(!isCollapsed || isMobile) && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ color: "#fff", fontWeight: "700", fontSize: "15px", letterSpacing: "0.5px" }}>POOJA SEVA</span>
              <span style={{ color: "#d9b8b0", fontSize: "11px" }}>Temple Management</span>
            </div>
          )}
        </div>

        {/* Navigation Items */}
        <div style={{ display: "flex", flexDirection: "column", gap: "4px", flexGrow: 1 }}>
          {currentMenu.map((item, index) => {
            const isActive = location.pathname === item.path || (item.path === "/home" && location.pathname === "/");
            const isHovered = hoveredIndex === index;

            return (
              <Link
                key={item.path}
                to={item.path}
                title={isCollapsed && !isMobile ? item.label : ""}
                style={getMenuItemStyle(isActive, isHovered)}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => isMobile && setIsOpenMobile(false)}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                  <FontAwesomeIcon 
                    icon={item.icon} 
                    style={{ 
                      width: "18px", 
                      fontSize: "16px", 
                      color: isActive || isHovered ? "#fff" : "#d9b8b0" 
                    }} 
                  />
                  {(!isCollapsed || isMobile) && <span>{item.label}</span>}
                </div>
                {isActive && (!isCollapsed || isMobile) && (
                  <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: "12px" }} />
                )}
              </Link>
            );
          })}
        </div>

        {/* Sign Out Button */}
        <div style={{ borderTop: "1px solid rgba(255, 255, 255, 0.08)", paddingTop: "12px", marginTop: "auto", flexShrink: 0 }}>
          <div
            style={getMenuItemStyle(false, hoveredIndex === "logout")}
            onMouseEnter={() => setHoveredIndex("logout")}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={handleLogout}
            title={isCollapsed && !isMobile ? "Sign Out" : ""}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <FaSignOutAlt style={{ fontSize: "16px", width: "18px" }} />
              {(!isCollapsed || isMobile) && <span>Sign Out</span>}
            </div>
          </div>
        </div>
      </aside>

      {/* Top Header Bar */}
      <header style={{
        height: "64px",
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #ffedd5",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 24px",
        boxSizing: "border-box",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        boxShadow: "0 1px 3px rgba(0,0,0,0.02)"
      }}>
        {/* Left: Collapse/Expand Toggle + Dynamic Page Header */}
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <button
            onClick={toggleSidebar}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              border: "1px solid #ffedd5",
              backgroundColor: "#fff7ed",
              color: "#5c1d11",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: "15px",
              outline: "none",
              transition: "all 0.2s ease"
            }}
          >
            <FontAwesomeIcon icon={isMobile ? (isOpenMobile ? faTimes : faBars) : (isCollapsed ? faBars : faTimes)} />
          </button>

          <div>
            <h1 style={{ margin: 0, fontSize: "15px", fontWeight: "700", color: "#111827", lineHeight: "1.2" }}>
              {getCurrentPageTitle()}
            </h1>
            <p style={{ margin: 0, fontSize: "12px", color: "#9ca3af" }}>
              Temple Management System
            </p>
          </div>
        </div>

        {/* Right: Notifications & Session Profile Details */}
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          {/* Notification Bell */}
          <div style={{ position: "relative", cursor: "pointer", display: "flex", alignItems: "center" }}>
            <FontAwesomeIcon icon={faBell} style={{ fontSize: "18px", color: "#6b7280" }} />
            <span style={{
              position: "absolute",
              top: "-2px",
              right: "-2px",
              width: "8px",
              height: "8px",
              backgroundColor: "#ea580c",
              borderRadius: "50%",
              border: "2px solid #ffffff"
            }} />
          </div>

          {/* User Profile Pill */}
          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                cursor: "pointer",
                padding: "4px 8px",
                borderRadius: "24px",
                transition: "background 0.2s"
              }}
            >
              <div style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#ea580c",
                color: "#ffffff",
                fontWeight: "700",
                fontSize: "13px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                {getInitials(userName)}
              </div>
              <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                <span style={{ fontSize: "13px", fontWeight: "600", color: "#111827", lineHeight: "1.2" }}>
                  {userName}
                </span>
                <span style={{ fontSize: "11px", color: "#6b7280" }}>
                  {role === "Admin" ? "Super Admin" : role}
                </span>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ borderRadius: "10px", boxShadow: "0 8px 24px rgba(0,0,0,0.12)", border: "1px solid #ffedd5" }}>
              <Dropdown.Item onClick={navigateToProfile} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 16px" }}>
                <FaUserCircle size={16} color="#5c1d11" /> Profile
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={handleLogout} style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 16px", color: "#dc2626" }}>
                <FaSignOutAlt size={16} /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>
    </>
  );
}

export default Sidebar;